import type { FC, SVGProps } from 'react';

export const RetoolLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 .75A.75.75 0 0 0 9.25 0H.75A.75.75 0 0 0 0 .75v3.5c0 .414.336.75.75.75h8.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75h5.5a.75.75 0 0 1 .75.75v2c0 .415.336.75.75.75h3.5a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 1-.75-.75v-2Z" />
  </svg>
);
